module.exports = __webpack_public_path__ + "79089cb07600bf4a0b5954d2d5a0a162.jpg";